export enum DataType {
    Float,
    Digital,
    PreviousStep
}